import { Grid, Breadcrumbs } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { DashboardLink } from 'utils/link';
import { BreadCrumbLink } from 'components/styles_components/link';
import theme from 'theme';

const BreadcrumbContainer = ({ children, hideMain }) => {
  return (
    <Grid direction="row" justifyContent="space-between">
      <Breadcrumbs
        aria-label="breadcrumb"
        separator="-"
        sx={{
          '& .MuiBreadcrumbs-li': { minWidth: 0 },
          '& .MuiBreadcrumbs-li > *': {
            display: 'inline-block',
            maxWidth: theme.width.limitedSpan,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'bottom',
          },
        }}
      >
        {!hideMain && (
          <BreadCrumbLink to={DashboardLink()}>
            <FormattedMessage id="breadcrumb.home" />
          </BreadCrumbLink>
        )}
        {children}
      </Breadcrumbs>
    </Grid>
  );
};

export default BreadcrumbContainer;
